import React, { useEffect, useReducer } from 'react';
import { KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN } from '../Constants/constant';

export const initialState = {
  isAuthenticated: false,
  user: null,
};

try {
  const user = JSON?.parse(localStorage?.getItem('user'));
  initialState.user = user;
  initialState.isAuthenticated = Object.keys(user).length > 0;
} catch (error) {
  // Error
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem(KEY_ACCESS_TOKEN, action?.payload?.user?.accessToken?.accessToken?.token);
      localStorage.setItem(KEY_REFRESH_TOKEN, action?.payload?.user?.refreshToken?.refreshToken?.token);
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };
    case 'LOGOUT':
      localStorage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    default:
      return state;
  }
};

export const AuthContext = React.createContext();

export const AuthContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const user = JSON?.parse(localStorage?.getItem('user'));
    if (user) {
      dispatch({
        type: 'LOGIN',
        payload: {
          user,
        },
      });
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
